export { FileThumbnail } from './FileThumbnail'
export type { FileThumbnailProps } from './FileThumbnail'
export { getExtension, getFileTypeIcon } from './fileTypeIcon'
